import React from 'react';
import {Tooltip} from 'material-ui';
import EditIcon from 'material-ui-icons/Edit';
import DeleteIcon from 'material-ui-icons/Delete';
import DisableIcon from 'material-ui-icons/VisibilityOff';
import EnableIcon from 'material-ui-icons/Visibility';
import {
    showEditGlobalButton,
    showEditTranslationButton,
    showDeleteGlobalButton,
    showDeleteTranslationButton,
    showEnableDisableButton,
} from '../../../../components/permissions/permissions';

const actions = ({
    classes, 
    editSection, 
    deletable, 
    visible, 
    invisible, 
    deleteSection, 
    disableSection, 
    enableSection, 
    siteId, 
    hideActions
}) => {

    const editSectionButton = 
        <span>
            {editSection &&
                <span className="floatRight">
                    <Tooltip title="Edit Section">
                        <EditIcon className="smallIconButtonPages editColor" onClick={editSection}/>
                    </Tooltip>
                </span>
            }
        </span>;

    const ShowEditSectionButton = siteId === 0 ?
        showEditGlobalButton(() => editSectionButton) : 
        showEditTranslationButton(() => editSectionButton);

    const deleteSectionButton = 
        <span>
            {deletable &&
                <span className="floatRight">
                    <Tooltip title="Delete Section">
                        <DeleteIcon className="smallIconButtonPages deleteColor" onClick={deleteSection}/>
                    </Tooltip>
                </span>
            }
        </span>;

    const ShowDeleteSectionButton = siteId === 0 ?
        showDeleteGlobalButton(() => deleteSectionButton) :
        showDeleteTranslationButton(() => deleteSectionButton);

    const EnableDisableSectionButton = showEnableDisableButton(() =>
        <span>
            {visible &&
                <span className="floatRight">
                    <Tooltip title="Disable Section">
                        <DisableIcon className="smallIconButtonPages disableColor" onClick={disableSection}/>
                    </Tooltip>
                </span>
            }
            {invisible &&
                <span className="floatRight">
                    <Tooltip title="Enable Section">
                        <EnableIcon className="smallIconButtonPages enableColor" onClick={enableSection}/>
                    </Tooltip>
                </span>
            }
        </span>
    );

    return (
        !hideActions &&
        <div className={classes.pbSectionActions}>
            <ShowDeleteSectionButton />
            <EnableDisableSectionButton />
            <ShowEditSectionButton />
        </div>
    );
};

export default actions;


// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_edit/section_actions.js